import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LibrariesModule } from '../../libraries/libraries.module';
import { HeaderTopComponent } from './header-top.component';
import { SharedModule } from '../../shared/shared.module';



@NgModule({
  declarations: [HeaderTopComponent],
  exports: [HeaderTopComponent],
  imports: [
    CommonModule, LibrariesModule,
    SharedModule
  ]
})
export class HeaderTopModule { }
